import { connect } from 'react-redux';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';
import { holdMusicActions } from '../actions/holdMusicActions';
import HoldMusicWithPlayer from './HoldMusicComponent';
export const { holdMusicGetAll, holdMusicUpload, holdMusicSplit, holdMusicReset, holdMusicShowModal, holdMusicHideModal, holdMusicSelect, holdMusicHoldingForSplitingClose, holdMusicHoldingForSplitingOpen, } = holdMusicActions;
const mapStateToProps = (state, ownProps) => {
    const allAudios = [];
    for (const audio of state.holdMusic.allAudios) {
        if (audio && audio.original_as_mp3_url) {
            allAudios.push(audio);
        }
    }
    return {
        allAudios,
        meta: state.holdMusic.meta,
        jobIds: state.holdMusic.jobIds,
        selectedAudio: state.holdMusic.selectedAudio,
        isNewAudioOpen: state.holdMusic.ui.isNewAudioOpen,
        isHoldingOpen: state.holdMusic.ui.isHoldingOpen,
        organization: state.settings.organization.organization,
        labelError: ownProps.labelError !== undefined && ownProps.labelError !== ''
            ? ownProps.labelError
            : null,
        className: ownProps.className !== undefined && ownProps.className !== ''
            ? ownProps.className
            : null,
    };
};
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        holdMusicGetAll: bindActionToPromise(dispatch, holdMusicGetAll),
        holdMusicUpload: bindActionToPromise(dispatch, holdMusicUpload),
        holdMusicSplit: bindActionToPromise(dispatch, holdMusicSplit),
        audioReset: () => dispatch(holdMusicReset()),
        onSelectedCallback: (payload) => ownProps.onSelectedCallback(payload),
        audioHideModal: () => dispatch(holdMusicHideModal()),
        audioShowModal: () => dispatch(holdMusicShowModal()),
        holdMusicSelect: (payload) => dispatch(holdMusicSelect(payload)),
        holdMusicHoldingForSplitingOpen: () => dispatch(holdMusicHoldingForSplitingOpen()),
        holdMusicHoldingForSplitingClose: () => dispatch(holdMusicHoldingForSplitingClose()),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(HoldMusicWithPlayer);
